var _path, _path2, _g, _rect, _rect2, _rect3, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48425 4.07031H27.5158C28.2315 4.07031 28.8126 4.65138 28.8126 5.36706V14.4934H3.1875V5.367C3.1875 4.65131 3.76856 4.07031 4.48425 4.07031Z",
    fill: "#A8D9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6657_14598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 20,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0215 29.2276H6.97867C6.67292 29.2276 6.42505 28.9797 6.42505 28.6739V5.55475L11.9799 0H25.0215C25.3273 0 25.5752 0.247875 25.5752 0.553625V28.6739C25.5752 28.9797 25.3273 29.2276 25.0215 29.2276Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6657_14598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0215 29.2276H6.97867C6.67292 29.2276 6.42505 28.9797 6.42505 28.6739V5.55475L11.9799 0H24.5215C25.2502 0 25.5752 0.5 25.5752 1.05362V28.6739C25.5752 28.9797 25.3273 29.2276 25.0215 29.2276Z",
    fill: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 -0.3125L9.30921 2.51219L6.125 5.5625H11.3224C11.6966 5.5625 12 5.25912 12 4.88491V-0.3125Z",
    fill: "#0F96FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 7.6875,
    width: 15,
    height: 1.25,
    rx: 0.625,
    fill: "#8FCEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 10.4375,
    width: 15,
    height: 1.25,
    rx: 0.625,
    fill: "#8FCEFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 13.1875,
    width: 15,
    height: 1.25,
    rx: 0.625,
    fill: "#8FCEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42505 22.8672V28.6747C6.42505 28.9805 6.67292 29.2284 6.97867 29.2284H25.0215C25.3272 29.2284 25.5751 28.9805 25.5751 28.6747V22.8672H6.42505Z",
    fill: "url(#paint0_linear_6657_14598)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.7143 14.1833H9.53906V9.97266L15.7143 14.1833Z",
    fill: "#007FE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92915 11.4385L9.88752 10.781C9.84421 10.0969 9.28371 9.56445 8.60684 9.56445H1.28365C0.492024 9.56445 -0.110851 10.2832 0.0172112 11.0743L3.22909 30.9115C3.33077 31.5396 3.8669 32.0008 4.49552 32.0008H28.005C28.6336 32.0008 29.1697 31.5396 29.2714 30.9115L31.9828 14.1649C32.1109 13.3738 31.5081 12.655 30.7164 12.655H11.2098C10.533 12.655 9.9724 12.1226 9.92915 11.4385Z",
    fill: "#BDE2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6657_14598",
    x1: 16.0001,
    y1: 27.2948,
    x2: 16.0001,
    y2: 29.3702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2667,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5933,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8545,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9713,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.28f440f1559a704952fa5ef9bee8bd0a.svg";
export { ForwardRef as ReactComponent };